import { useStore } from "@/store/index";
export default {
  mounted(el, binding) {
    const store = useStore();
    if (!store.btnApi.includes(binding.value)) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  },
};
